import React from 'react';
import { Button } from '../../../../../ui';
import { Copy, Flexer } from '../../../../dashboard/elements/LayoutElements';
import { SetupStep, StepProps } from './SetupStep';

export const CommonFinalStep: React.FC<StepProps> = ({ gotoStep }) => {
    return (
        <SetupStep title="Step 4 — Finalize Setup">
            <Copy flush>
                <p>
                    Your SSO integration should now be configured! Here are some final steps to ensure everything works correctly:
                </p>
                <ol>
                    <li>Grant access for the appropriate users or groups to Ludi in your Identity Provider.</li>
                    <li>Test the SSO login by having a user attempt to sign in through your Identity Provider.</li>
                    <li>If you encounter any issues, verify that all the configuration values match exactly between Ludi and your Identity Provider.</li>
                </ol>
            </Copy>
            <Copy flush>
                <p>
                    Common troubleshooting tips:
                </p>
                <ul>
                    <li>Certificate format issues: Ensure the certificate is properly formatted with all line breaks intact.</li>
                    <li>URL mismatches: Double-check that all URLs are exact matches, including http/https protocols.</li>
                    <li>Attribute mapping: Verify that your IDP is correctly mapping and sending the required user attributes.</li>
                </ul>
            </Copy>
            <Copy bold flush>
                <p>
                    With Single Sign-On enabled, all non-guest users will be required to authenticate at least once via your Identity Provider before accessing the tool.
                    You can further tweak how often and which users need to authenticate on the main configuration screen.
                </p>
            </Copy>
            <Flexer flex="row" justify="end">
                <Button variant="primary" onAction={() => gotoStep('end')}>
                    View Configuration
                </Button>
            </Flexer>
        </SetupStep>
    );
};
